<template>
  <b-modal :active.sync="show"
           class="card-form-modal"
           :custom-class="'dialog mpc'"
           trap-focus
           has-modal-card
           :can-cancel="true"
           ref="modal"
           :destroy-on-hide="true"
           aria-role="dialog"
           aria-modal
           @close="close">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">
          Crop & rotate
        </p>
        <div class="cl-btn-7" @click="close"></div>
      </header>
      <div class="content">
        <section class="cropper-area">
          <div class="img-cropper">
            <cropper
              ref="cropper"
              class="cropper"
              @ready="ready"
              :src="file"
              :canvas="{
                  maxArea: 654 * 435
              }"
              :stencil-size="{
                  width: width,
                  height: height
              }"
              :stencil-props="{
                  handlers: {},
                  movable: false,
                  resizable: false,
                  aspectRatio: width/height,
              }"
              :resize-image="{
                  adjustStencil: false
              }"
              :default-size="defaultSize"
              image-restriction="none"
              default-boundaries="fill"
            >
            </cropper>
          </div>
        </section>
      </div>
      <div class="card-content">
        <b-button class="btn-undo" @click="reset">
          Undo
        </b-button>
        <b-button class="btn-zoom-in" @click="zoomIn">
          Zoom In
        </b-button>
        <b-button class="btn-zoom-out" @click="zoomOut">
          Zoom Out
        </b-button>
        <b-button class="square-button-right" @click="rotateClockwise"
                  title="Rotate Clockwise">
        </b-button>
        <b-button class="square-button" @click="rotateCounterClockwise"
                  title="Rotate Counter-Clockwise">
        </b-button>
      </div>
      <footer class="card-footer">
        <a @click="close" class="card-footer-item">CANCEL</a>
        <a id="btn-done" @click="doneEditing" class="card-footer-item">DONE</a>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';

export default {
  name: 'EditImage',
  components: {
    Cropper,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    file: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 218,
    },
    height: {
      type: Number,
      default: 145,
    },
  },
  data() {
    return {
    };
  },
  mounted() {
    const modal = this.$refs.modal.$el;
    modal.addEventListener('keydown', (event) => {
      if (event.keyCode === 13) {
        this.doneEditing();
      }
    });
  },
  methods: {
    defaultSize() {
      return {
        width: this.width,
        height: this.height,
      };
    },
    ready() {
      const modal = this.$refs.modal.$el;
      const elem = modal.getElementsByClassName('btn-undo')[0];
      elem.focus();
    },
    close() {
      this.$emit('close');
      this.show = false;
    },
    doneEditing() {
      try {
        const { canvas } = this.$refs.cropper.getResult();
        canvas.toBlob((blob) => {
          if (this.getBlobSizeMb(blob) > 1.024) {
            this.$buefy.toast.open({ message: 'The uploading file cannot be more than 1 MB', type: 'is-danger' });
          } else {
            this.$emit('submit', blob);
            this.show = false;
          }
        }, 'image/png');
      } catch (err) {
        this.$buefy.toast.open({ message: 'Please upload file in PNG, GIF, or JPG format', type: 'is-danger' });
        this.$emit('close');
        this.show = false;
      }
    },
    getBlobSizeMb(blob) {
      return Math.round((blob.size / 1024 / 1024) * 1000) / 1000;
    },
    reset() {
      this.$refs.cropper.reset();
    },
    rotateClockwise() {
      this.$refs.cropper.rotate(15);
    },
    rotateCounterClockwise() {
      this.$refs.cropper.rotate(-15);
    },
    zoomIn() {
      this.$refs.cropper.zoom(1.1);
    },
    zoomOut() {
      this.$refs.cropper.zoom(0.9);
    },
  },
};
</script>

<style scoped lang="stylus">
.is-size-7
  font-size: .9rem!important
.card-title
  line-height: 1.2
.b-checkbox a
  text-decoration: underline
.cropper {
  width: 100%;
  height: 100%;
  background: #DDD;
}
.square-button {
  background: rgba(0,0,0,.4);
  background: url("/img/icons/rotate-36.png");
  background-position: center;
  background-size: contain;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
  cursor: pointer;
  transition: background .5s;
}
.square-button:hover {
  opacity: 0.8;
}
.square-button:active {
  transform: scale(0.95);
}
.square-button-right {
  background: rgba(0,0,0,.4);
  background: url("/img/icons/rotate-36-right.png");
  background-position: center;
  background-size: contain;
  align-items: center;
  justify-content: center;
  height: 36px;
  width: 36px;
  cursor: pointer;
  transition: background .5s;
}
.square-button-right:hover {
  opacity: 0.8;
}
.square-button-right:active {
  transform: scale(0.95);
}
.mpc
  >>> .animation-content
    max-width none !important
    width 80%
    position relative
    .card
      max-width 100vw
      max-height 100vh
      height fit-content
      &.active
        display block
    @media(max-width:650px)
      width calc(100% - 10px)
.content
  padding: 0.2rem;
  margin-bottom: 0rem !important;
.card-header-title
.card-content
  padding: 0.6rem;
  @media (max-width 768px)
    padding: 0.4rem;
  @media (max-height 450px)
    padding: 0.4rem;
.img-cropper
  overflow hidden
  height: 600px;
  background: #DDD;
  @media (max-height 800px)
    max-height 63vh
  @media (max-height 650px)
    max-height 59vh
  @media (max-height 550px)
    max-height 56vh
  @media (max-height 500px)
    max-height 53vh
  @media (max-height 450px)
    max-height 48vh
  @media (max-height 400px)
    max-height 45vh
  @media (max-height 350px)
    max-height 40vh
  @media (max-height 300px)
    max-height 30vh
  @media (max-height 250px)
    max-height 20vh
  @media (max-height 200px)
    max-height 13vh
  @media (max-height 150px)
    max-height 8vh
  @media (max-height 100px)
    max-height 5vh
.img-cropper >>> .cropper-container
  max-height 500px
.img-cropper >>> .cropper-container canvas
  height 600px
  width 100%
  max-height 500px
.card-content
  @media (max-width 320px)
    >>> button
      font-size 15.5px
.square-button
.square-button-right
  @media (max-width 320px)
    height: 35px;
    width: 35px;
.card-footer
  border-top: 0
  >>> a
    margin-left 1px
    margin-right 1px
    margin-bottom 1px
    border 1px solid rgba(82, 95, 102, 0.3)
    border-radius 4px
  >>> a:hover
    border 1px solid rgba(82, 95, 102, 0.7)
  @media (max-width 768px)
    >>> a
      font-size 19px
      height 6vh
  @media (max-height 800px)
    >>> a
      height 7vh
  @media (max-height 600px)
    >>> a
      height 8vh
  @media (max-height 450px)
    >>> a
      height 9vh
  @media (max-height 400px)
    >>> a
      height 10vh
  @media (max-height 350px)
    >>> a
      height 11vh
  @media (max-height 300px)
    >>> a
      height 12vh
  @media (max-height 250px)
    >>> a
      height 13vh
  @media (max-height 200px)
    >>> a
      height 14vh
  @media (max-height 150px)
    >>> a
      height 15vh
.card-footer-item
  color #525f66
  @media (max-width 768px)
    padding: 0.2rem;
  @media (max-height 450px)
    padding: 0.2rem;
.card-footer-item:hover
  color #363636
.card-footer-item#btn-done
  color #68BA62
.card-footer-item#btn-done:hover
  color #17B548
.cl-btn-7 {
  width: 40px;
  height: 40px;
  border-radius: 40px;
  position: relative;
  z-index: 1;
  margin: auto;
  cursor: pointer;
}
.cl-btn-7:before {
  content: '+';
  color: #525f66;
  position: absolute;
  z-index: 2;
  transform: rotate(45deg);
  font-size: 50px;
  line-height: 1;
  top: -5px;
  left: 6px;
  transition: all 0.3s cubic-bezier(0.77, 0, 0.2, 0.85);
}
.cl-btn-7:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  z-index: 1;
  transition: all 0.3s cubic-bezier(0.77, 0, 0.2, 0.85);
  transform: scale(0.01);
}
.cl-btn-7:hover:after {
  transform: scale(1);
}
.cl-btn-7:hover:before {
  transform: scale(0.9) rotate(45deg);
  color: #525f66;
}
</style>
